import React from 'react';
import ReactDOM from 'react-dom/client';
import './media/css/MyBootstrap.css';
import './media/css/index.css';
import './glob.js';
import App from './App.mjs';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('appRootNode'));
window.app = <App />;
root.render(
  <React.StrictMode>
      {window.app}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
